import React from "react";

import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

const reduceChildRoutes = (props) => {
    const {items, page, depth} = props;
    const id = window.location.pathname.split("/")[1]
    if (page.children) {
        const open = false;

        items.push(
            <SidebarNavListItem
                depth={depth}
                icon={page.icon}
                key={page.title}
                badge={page.badge}
                open={!!open}
                title={page.title}
                href={"/" + id + page.href}
            >
                <SidebarNavList depth={depth + 1} pages={page.children}/>
            </SidebarNavListItem>
        );
    } else {
        items.push(
            <SidebarNavListItem
                depth={depth}
                href={"/" + id + page.href}
                icon={page.icon}
                key={page.title}
                badge={page.badge}
                title={page.title}
            />
        );
    }

    return items;
};

export default reduceChildRoutes;
